<template>
  <b-container style="width:700px;">
    <b-card>
      <h3>Import Access Codes</h3>
      <br />
      <b-card-text>
        <b-input-group prepend="CSV File">
          <b-form-file v-model="form.file" type="file"></b-form-file>
          <b-input-group-append>
            <b-button variant="success" @click="submitFile">Submit
              <b-spinner v-if="this.isSending" class="m-1" label="Spinning" small />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <ul class="mt-3 mb-0">
          <li v-for="error in import_errors" :key="error" style="color:red">{{ error }}</li>
        </ul>
        <div v-if="imported">{{ imported.message }}</div>
      </b-card-text>
      <b-card-text v-if="imported && noticed">
        <b-table :bordered="true" :small="true" :items="with_notices"></b-table>
      </b-card-text>
      <b-card-text v-if="imported && failed">
        Access codes not imported:
        <b-table :bordered="true" :small="true" :items="not_imported"></b-table>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import { importCoupons } from "../../utils/twa-api";

export default {
  data() {
    return {
      form: {
        file: this.$route.params.file
      },
      isSending: false,
      import_errors: [],
      not_imported: [],
      with_notices: [],
      imported: null,
      failed: false,
      noticed: false
    }
  },
  methods: {
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    async submitFile() {
      this.isSending = true
      this.import_errors = []
      this.not_imported = []
      this.with_notices = []
      this.imported = null
      this.failed = false
      this.noticed = false

      try {
        this.imported = await importCoupons(this.form.file);
        if (this.imported.noticed_coupons) {
          this.noticed = true;
          this.imported.noticed_coupons.forEach(element => {
            this.with_notices.push({ access_code: element.coupon.coupon_code, product: element.product, reason: element.reason })
          })
        }
        if (this.imported.failed_coupons) {
          this.failed = true;
          this.imported.failed_coupons.forEach(element => {
            this.not_imported.push({ access_code: element.coupon.coupon_code, product: element.product, reason: element.reason })
          })
        }
        console.log(this.imported.message)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // do nothing
        } else if (error.response && error.response.status === 500) {
          this.import_errors.push("Internal Server Error");
        } else {
          console.log(error)
        }
      }
      this.isSending = false
    }
  }
}
</script>